"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Swiper", {
  enumerable: true,
  get: function get() {
    return _coreClass["default"];
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _coreClass["default"];
  }
});
Object.defineProperty(exports, "Virtual", {
  enumerable: true,
  get: function get() {
    return _virtual["default"];
  }
});
Object.defineProperty(exports, "Keyboard", {
  enumerable: true,
  get: function get() {
    return _keyboard["default"];
  }
});
Object.defineProperty(exports, "Mousewheel", {
  enumerable: true,
  get: function get() {
    return _mousewheel["default"];
  }
});
Object.defineProperty(exports, "Navigation", {
  enumerable: true,
  get: function get() {
    return _navigation["default"];
  }
});
Object.defineProperty(exports, "Pagination", {
  enumerable: true,
  get: function get() {
    return _pagination["default"];
  }
});
Object.defineProperty(exports, "Scrollbar", {
  enumerable: true,
  get: function get() {
    return _scrollbar["default"];
  }
});
Object.defineProperty(exports, "Parallax", {
  enumerable: true,
  get: function get() {
    return _parallax["default"];
  }
});
Object.defineProperty(exports, "Zoom", {
  enumerable: true,
  get: function get() {
    return _zoom["default"];
  }
});
Object.defineProperty(exports, "Lazy", {
  enumerable: true,
  get: function get() {
    return _lazy["default"];
  }
});
Object.defineProperty(exports, "Controller", {
  enumerable: true,
  get: function get() {
    return _controller["default"];
  }
});
Object.defineProperty(exports, "A11y", {
  enumerable: true,
  get: function get() {
    return _a11y["default"];
  }
});
Object.defineProperty(exports, "History", {
  enumerable: true,
  get: function get() {
    return _history["default"];
  }
});
Object.defineProperty(exports, "HashNavigation", {
  enumerable: true,
  get: function get() {
    return _hashNavigation["default"];
  }
});
Object.defineProperty(exports, "Autoplay", {
  enumerable: true,
  get: function get() {
    return _autoplay["default"];
  }
});
Object.defineProperty(exports, "EffectFade", {
  enumerable: true,
  get: function get() {
    return _effectFade["default"];
  }
});
Object.defineProperty(exports, "EffectCube", {
  enumerable: true,
  get: function get() {
    return _effectCube["default"];
  }
});
Object.defineProperty(exports, "EffectFlip", {
  enumerable: true,
  get: function get() {
    return _effectFlip["default"];
  }
});
Object.defineProperty(exports, "EffectCoverflow", {
  enumerable: true,
  get: function get() {
    return _effectCoverflow["default"];
  }
});
Object.defineProperty(exports, "Thumbs", {
  enumerable: true,
  get: function get() {
    return _thumbs["default"];
  }
});

var _coreClass = _interopRequireDefault(require("./esm/components/core/core-class"));

var _virtual = _interopRequireDefault(require("./esm/components/virtual/virtual"));

var _keyboard = _interopRequireDefault(require("./esm/components/keyboard/keyboard"));

var _mousewheel = _interopRequireDefault(require("./esm/components/mousewheel/mousewheel"));

var _navigation = _interopRequireDefault(require("./esm/components/navigation/navigation"));

var _pagination = _interopRequireDefault(require("./esm/components/pagination/pagination"));

var _scrollbar = _interopRequireDefault(require("./esm/components/scrollbar/scrollbar"));

var _parallax = _interopRequireDefault(require("./esm/components/parallax/parallax"));

var _zoom = _interopRequireDefault(require("./esm/components/zoom/zoom"));

var _lazy = _interopRequireDefault(require("./esm/components/lazy/lazy"));

var _controller = _interopRequireDefault(require("./esm/components/controller/controller"));

var _a11y = _interopRequireDefault(require("./esm/components/a11y/a11y"));

var _history = _interopRequireDefault(require("./esm/components/history/history"));

var _hashNavigation = _interopRequireDefault(require("./esm/components/hash-navigation/hash-navigation"));

var _autoplay = _interopRequireDefault(require("./esm/components/autoplay/autoplay"));

var _effectFade = _interopRequireDefault(require("./esm/components/effect-fade/effect-fade"));

var _effectCube = _interopRequireDefault(require("./esm/components/effect-cube/effect-cube"));

var _effectFlip = _interopRequireDefault(require("./esm/components/effect-flip/effect-flip"));

var _effectCoverflow = _interopRequireDefault(require("./esm/components/effect-coverflow/effect-coverflow"));

var _thumbs = _interopRequireDefault(require("./esm/components/thumbs/thumbs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Swiper 6.3.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://swiperjs.com
 *
 * Copyright 2014-2020 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 25, 2020
 */
// Swiper Class
var components = [];

_coreClass["default"].use(components);